import { RetailerThemeStyles } from "@narvar/nth-hook-theme";

export const themeTokens: (keyof RetailerThemeStyles)[] = [
  "linksNoneDefault",
  "linksNoneHover",
  "buttonsPrimaryDefault",
  "buttonsPrimaryHover",
  "bodytextDefaultNone",
];
